export const LIST_BOOKING = 'LIST_BOOKING';
export const LIST_EVENTS = 'LIST_EVENTS';
export const GET_AMOUNT_LEFT_TO_COLLECT_BY_COMPANY =
  'GET_AMOUNT_LEFT_TO_COLLECT_BY_COMPANY';
export const LIST_DELIVERY_ROUTE = 'LIST_DELIVERY_ROUTE';
export const LIST_DELIVERY_ROUTE_CHATS = 'LIST_DELIVERY_ROUTE_CHATS';
